import React from "react";
import classNames from "classnames";

import { ChevronIcon } from "@common/calendar/chevronIcon";
import { getDecade, chunkByDecade } from "@common/calendar/years/utils";
import { Props } from "./types";
import styles from "./styles.scss";

function Years(props: Props) {
  const cursorYear = props.cursor.getFullYear();
  const decade = getDecade(cursorYear);

  return (
    <div className={styles.calendar}>
      <div className={styles.heading}>
        <div
          className={styles.iconBox}
          onClick={(e) => {
            e.stopPropagation();
            props.editCursor(cursorYear - 10);
          }}
        >
          <ChevronIcon className={classNames(styles.icon, styles.leftIcon)} />
        </div>
        <h3 className={styles.title}>
          {decade.min} - {decade.max}
        </h3>
        <div
          className={styles.iconBox}
          onClick={(e) => {
            e.stopPropagation();
            props.editCursor(cursorYear + 10);
          }}
        >
          <ChevronIcon className={classNames(styles.icon, styles.rightIcon)} />
        </div>
      </div>
      <ul className={styles.main}>
        {chunkByDecade(decade).map((years, chunkIndex) => (
          <li key={chunkIndex} className={styles.years}>
            <ul className={styles.row}>
              {years.map((year) => (
                <li
                  key={year}
                  className={classNames(styles.year, {
                    [styles.selected]: year === props.year,
                  })}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.select(year);
                  }}
                >
                  <p className={styles.name}>{year}</p>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
}

export { Years };
